export default [
    { value: 'offer', text: 'Offer' },
    { value: 'advertiser', text: 'Advertiser' },
];
